export default __webpack_public_path__ + "assets/images/166ab9242cb38ffb1675ea42f8c222d7.png";